import { useEffect, useState } from 'react';
import _ from 'lodash';

const useIsScrollableRef = ({ ref, dependencies = [] }) => {
  const [isScrollableX, setIsScrollableX] = useState(false);
  const [isScrollableY, setIsScrollableY] = useState(false);

  useEffect(() => {
    const xWidth = _.get(ref.current, 'clientWidth');
    const xScroll = _.get(ref.current, 'scrollWidth');
    setIsScrollableX(xScroll > xWidth);
  }, dependencies);

  useEffect(() => {
    const yHeight = _.get(ref.current, 'clientHeight');
    const yScroll = _.get(ref.current, 'scrollHeight');
    setIsScrollableY(yScroll > yHeight);
  }, dependencies);

  return {
    x: isScrollableX,
    y: isScrollableY
  };
};

export default useIsScrollableRef;
